<script lang="ts">
    import type { InstallmentPlan } from '@shared/types/types';

    interface Props {
        installmentPlan?: InstallmentPlan;
    }

    let { installmentPlan }: Props = $props();

    const installmentPrice = $derived.by(() => {
        if (!installmentPlan?.amount) {
            return;
        }
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        }).format(installmentPlan.amount);
    });
</script>

{#if installmentPlan}
    <span class="oc-copy-75" data-testid="reptile-installments"
        ><span class="oc-copy--bold">{installmentPrice}</span> mtl. in {installmentPlan?.count}
        Raten</span
    >
{/if}
